export const PRODUCTION = import.meta.env.PROD;
export const DEVELOPMENT = import.meta.env.DEV;
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const VIRTUAL_ENV = import.meta.env.VITE_VIRTUAL_ENV;
export const IS_VIRTUAL_DEVELOPMENT = VIRTUAL_ENV === "development";
export const SENTRY_ORG = import.meta.env.VITE_SENTRY_ORG;
export const SENTRY_PROJECT = import.meta.env.VITE_SENTRY_PROJECT;
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const SENTRY_ENVIRONMENT =
  import.meta.env.VITE_SENTRY_ENVIRONMENT || VIRTUAL_ENV;
export const GOOGLE_WEB_CLIENT_ID = import.meta.env.VITE_GOOGLE_WEB_CLIENT_ID;
export const GITHUB_CLIENT_ID = import.meta.env.VITE_GITHUB_CLIENT_ID;
export const GITHUB_OAUTH_REDIRECT_URI = import.meta.env
  .VITE_GITHUB_OAUTH_REDIRECT_URI;
export const LINKEDIN_CLIENT_ID = import.meta.env.VITE_LINKEDIN_CLIENT_ID;
export const LINKEDIN_OAUTH_REDIRECT_URI = import.meta.env
  .VITE_LINKEDIN_OAUTH_REDIRECT_URI;
